import React, { useEffect, useState } from "react";
import { store } from "react-notifications-component";
import { NO_LOGGED_ERROR_MESSAGE } from "../../app/components/FinalizePage/hooks/useBasketManager";

interface IProps {
  errors: string[] | null;
  onHide: Function;
}

const ErrorAlerts: React.FC<IProps> = ({ errors, onHide }: IProps) => {
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  useEffect(() => {
    const errorNotifications = () => {
      let error = errors ? errors.reduce((acc: string, item: string) => `${acc} ${item}`, "") : ``;
      if (
        error === null ||
        error === undefined ||
        !error ||
        error === "null" ||
        error.includes(NO_LOGGED_ERROR_MESSAGE)
      ) {
        error = "";
      }

      // Wyświetlaj tylko komunikaty o braku wolnych miejsc
      const isNoPlacesMessage = error.includes("Brak wolnych miejsc");

      if (!errorDisplayed && Boolean(error) && isNoPlacesMessage) {
        store.addNotification({
          title: "Wystąpił błąd!",
          message: error,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
            showIcon: true,
          },
          onRemoval: () => {
            onHide();
            setErrorDisplayed(false);
          },
        });
        setErrorDisplayed(true);
      }
    };

    if (errors) {
      errorNotifications();
    }
    //eslint-disable-next-line
  }, [errors]);
  return <React.Fragment></React.Fragment>;
};

export default ErrorAlerts;
